import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";
import moment from "moment";

export class PollingTimeoutError extends Error {}

export default async (taskId, onUpdate, timeout = 360) => {
  let lastSeenStep = 0;
  let status = {};
  let timeSinceLastChange = moment();
  const MAX_TIMEOUT = 360;
  const updateTimeout = Math.min(MAX_TIMEOUT, timeout);

  do {
    if (moment().diff(timeSinceLastChange, "seconds") >= updateTimeout)
      throw new PollingTimeoutError(
        `Polling event did not receive any update in ${timeout} seconds.`
      );

    try {
      const config = {
        method: "GET",
        url: buildRequestUrl(
          { last_seen_step: lastSeenStep },
          `status/${taskId}`
        ),
      };
      // We want to wait in each iteration, so we disable the linter rule
      // eslint-disable-next-line no-await-in-loop
      const response = await athenaClient(config);
      status = response.data;

      if (lastSeenStep !== status.task_info?.step)
        // Reset timer
        timeSinceLastChange = moment();
      lastSeenStep = status.task_info?.step || lastSeenStep;

      onUpdate(status);
    } catch (error) {
      // For 504 errors, continue looping
      if (error.response?.status !== 504) {
        throw error;
      }
    }
  } while (
    status.task_status !== "FAILURE" &&
    status.task_status !== "SUCCESS"
  );

  return status;
};

export const getStatusWithoutPolling = async (taskId) => {
  const config = {
    method: "GET",
    url: buildRequestUrl({}, `status/${taskId}`),
  };
  // We want to wait in each iteration, so we disable the linter rule
  // eslint-disable-next-line no-await-in-loop
  const response = await athenaClient(config);
  return response.data;
};
